import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

/**
 * Replaces `page:app-visualizer` from `@backstage/plugin-app-visualizer`
 * (ADR-0012). The stock page renders the extension tree through
 * `DependencyGraph` from `@backstage/core-components` with hardcoded blues —
 * a sprawling force-laid graph that is unreadable at this portal's extension
 * count, and which hides the one thing worth knowing: whether an extension
 * actually got built and attached.
 *
 * This override keeps the `/visualizer` route but renders a collapsible
 * indented tree with search, kind/health/plugin filters, and a per-extension
 * detail panel. The stock sub-pages and nav item are disabled in
 * `app-config.yaml` because this page owns its own tabs and the sidebar has
 * its own entry.
 */
export const appVisualizerModule = createFrontendModule({
  pluginId: 'app-visualizer',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/visualizer',
        noHeader: true,
        routeRef: createRouteRef(),
        loader: () =>
          import('./AppAnatomyPage').then(m => (
            <PageErrorBoundary title="Portal Anatomy">
              <m.AppAnatomyPage />
            </PageErrorBoundary>
          )),
      },
    }),
  ],
});
